import React from 'react';
import { FaExclamationTriangle, FaTimes } from 'react-icons/fa';
import styles from './ConfirmationModal.module.css';

const ConfirmationModal = ({ message, onConfirm, onCancel }) => {
  return (
    <div className={styles.modalBackdrop} onClick={onCancel}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>
            <FaExclamationTriangle className={styles.warningIcon} />
            Onay Gerekli
          </h2>
          <button 
            className={styles.closeButton} 
            onClick={onCancel}
            aria-label="Kapat"
          >
            <FaTimes />
          </button>
        </div>
        
        <div className={styles.modalBody}>
          <p className={styles.message}>{message}</p>
        </div>
        
        <div className={styles.modalFooter}>
          <button 
            className={styles.cancelButton} 
            onClick={onCancel}
          >
            İptal
          </button>
          <button 
            className={styles.confirmButton} 
            onClick={onConfirm}
          >
            Evet, Eminim
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
